import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import GoodsAction from './GoodsAction'

Vue.use(CreateAPI)

Vue.createAPI(GoodsAction, true)

let instance = null

export default {
  show(params) {
    instance = GoodsAction.$create({
      $props: {}
    }).show(params)
  },
  hide() {
    if (instance) {
      instance.hide()
    }
  }
}
